// extracted by mini-css-extract-plugin
export default {"title":"Title_title__NV-qN","subTitle":"Title_subTitle__rGF5S"};